export const PASSWORD_MIN_LENGTH = 10;
export const PASSWORD_MAX_LENGTH = 128;

const DIGIT = /\d/;
const SYMBOL = /[^A-Za-z0-9]/;
const UPPER = /[A-Z]/;

export function isPasswordStrong(value: string): boolean {
  if (value.length < PASSWORD_MIN_LENGTH || value.length > PASSWORD_MAX_LENGTH) {
    return false;
  }
  const classes = [DIGIT, SYMBOL, UPPER].filter((re) => re.test(value)).length;
  return classes >= 2;
}

export function passwordPolicyHint(locale: "fr" | "en"): string {
  return locale === "fr"
    ? "10 caractères minimum, avec 2 parmi chiffre, symbole, majuscule"
    : "At least 10 characters, with 2 of: digit, symbol, uppercase";
}

export function passwordPolicyError(locale: "fr" | "en"): string {
  return locale === "fr"
    ? "Mot de passe : 10 caractères minimum, avec 2 parmi chiffre, symbole, majuscule"
    : "Password: at least 10 characters, with 2 of: digit, symbol, uppercase";
}
